import { Coolwhip, Divider } from '@circlefin/components'
import { Footer, HeaderPublic } from '@containers/layout'
import { Main } from '@shared/components/layout'
import { BaseLayout } from '@shared/layout/core'
import classNames from 'classnames'

import type { AppLayoutType } from '@shared/layout/core'

export interface GetStartedLayoutProps {
  /**
   * Center content within the main tag.
   */
  centerContent?: boolean
}

export const GetStartedLayout: AppLayoutType<GetStartedLayoutProps> = ({
  children,
  centerContent = true,
}) => {
  return (
    <BaseLayout className="grid-rows-[min-content_auto_min-content]">
      <div>
        <HeaderPublic>
          <HeaderPublic.Logo align="center" variant="mobile-full" />
          <HeaderPublic.SignIn className="hidden sm:block" />
          <HeaderPublic.LogOut />
        </HeaderPublic>

        <Divider />
      </div>
      <Coolwhip
        className="fixed bottom-0 h-screen w-full translate-y-56 opacity-0 md:opacity-100"
        variant="fade-top/green-blue-violet"
      />
      <Main
        className={classNames('relative overflow-y-auto h-full w-full', {
          'mx-auto': centerContent,
        })}
      >
        {children}
      </Main>
      <Footer />
    </BaseLayout>
  )
}
